
import React from "react";
import {
  TextInput,

} from "react-admin";
// import { useRedirect, useMutation, useNotify } from "react-admin";
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { Form } from "react-final-form"
// import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
} from "@material-ui/core";
import { useHistory } from "react-router-dom"
import {useCertificationsCreate} from './hooks'

const AddCertificationForm = ({
  handleSubmit,
  reset,
  submitting,
  pristine,
  values,
  props,
  onClose,
  ...rest
}) => {
  return (<form onSubmit={handleSubmit} noValidate>
    <Grid item xs={12}>
      <TextInput
        source="certificateName"
        variant="standard"
        fullWidth
        label="Enter Certification"
      />
    </Grid>
    <Grid item xs={12} style={{ marginTop: 16, width: "100%" }}>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        style={{ width: "100%" }}
      >
        Add
      </Button>
    </Grid>
    <Grid item xs={12} style={{ marginTop: 16, width: "100%" }}>
      <Button
        variant="contained"
        color="primary"
        onClick={onClose}
        style={{ width: "100%" }}
      >

        Cancel              
      </Button>
    </Grid>
  </form>)
}

const AddCertification = () => {
  const {createCertification} = useCertificationsCreate()
  // const dataProvider = useDataProvider();
  // const redirect = useRedirect()
  // const notify = useNotify();
  const history = useHistory()
  const handleClose = () => history.goBack()
  return (
    <Grid container>
      <Dialog
        open={true}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        Width="lg"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          Add Certification
        </DialogTitle>
        <DialogContent>
          <Form
            keepDirtyOnReinitialize
            render={AddCertificationForm}
            onClose={handleClose}
            onSubmit={async(response) => {
              await createCertification(response).then(r=>{
              })
              handleClose()
             }}
          >
          </Form>
        </DialogContent>

      </Dialog>
    </Grid>
  );
};


export default AddCertification